import app from '../app'
import i18nPlugin, { i18n } from './Helper/i18n'
import './Helper/translation'

app.use(i18nPlugin)

// add translations directly to the application
let language = {};
try {
    language = JSON.parse(window.localStorage.getItem('app-languages') || '{}') || {};
} catch (e) {
    language = {};
}
let key = window.localStorage.getItem('app-language') || 'en';
i18n.add(key, language);
// set the start locale to use
i18n.set(key);
/*------ localization end ------*/
